import { MenuItem, Select } from "@mui/material"
import { Translate } from "react-i18nify"

const StatusSelector = ({statusList, selectedStatus, deviceStatus, handleStatusChange, isO2maticQA, disabled}) => {
    return (
        <Select
            required
            id="StatusSelector"
            value={selectedStatus}
            onChange={handleStatusChange}
            sx={{ width:"100%" }}
            disabled={disabled}
        >
            {
                statusList.map(value =>{
                    const item = <MenuItem key={value.id} value={value.id}><Translate value={value.value}/></MenuItem>
                    if(isO2maticQA === true && deviceStatus?.value === "ClinicalInvestigation" && (value.value === "ReadyForInvestigation" || value.value === "SCRAPPED" || value.id===deviceStatus?.id)){
                        return item
                    }
                    if(isO2maticQA === true && value.value === "ClinicalInvestigation" && deviceStatus?.value !== "SCRAPPED"){
                        return item
                    }

                    if(deviceStatus?.value=="SCRAPPED") {
                        // show only SCRAPPED status (it should not be possible to change the status of a scrapped device)
                        if(value.id===deviceStatus?.id){
                            return item
                        }
                    } else if (deviceStatus?.value=="Assembled" || deviceStatus?.value=="Tested" || deviceStatus?.value=="ReadyForRepair" || deviceStatus?.value=="Packaged") { 
                        // id device has a status from the production flow prior to production QA approval, device status cannot be changed to anything but SCRAPPED or current status
                        if(value.value==="SCRAPPED" ||value.id===deviceStatus?.id){
                            return item
                        }
                    } else if (deviceStatus?.value == "Development" || deviceStatus?.value == "Verification"){
                        //if the current status is developmnent or verification only an o2matic QA user cab change the status
                        if(isO2maticQA === true)
                        {
                            if(value.value == "ReadyForInvestigation" || value.value == "Verification" || value.value == "Development") //value.id===device.metaData?.find(x => x.metadataId == 2)
                                return item
                        }else if(value.id===deviceStatus?.id){
                            return item
                        }
                    } else {
                        if(deviceStatus?.value !== "ClinicalInvestigation" && (value.value==="ReadyForInvestigation"||value.value==="AtRepairO2matic"||value.value==="ReadyForTesting"||value.value==="SCRAPPED"||value.id===deviceStatus?.id)){
                            return item
                        }
                    }
                    if(deviceStatus?.value == "AtRepairO2matic" || 
                        deviceStatus?.value == "Development" || 
                        deviceStatus?.value == "ReadyForInvestigation" || 
                        deviceStatus?.value == "ReadyForO2maticApproval" || 
                        deviceStatus?.value == "ReadyForTesting" ||
                        deviceStatus?.value == "Received" ||
                        deviceStatus?.value == "ReleasedForSale" ||
                        deviceStatus?.value == "RepairDone" ||
                        deviceStatus?.value == "Shipped" ||
                        deviceStatus?.value == "Prod QA Approved" || 
                        deviceStatus?.value == "Approved"  ||
                        deviceStatus?.value == "Verification"
                    ){ 
                        if((value.value == "Development" || value.value == "Verification" || value.id===deviceStatus?.id) && isO2maticQA === true)
                        return item
                    }  
                })
            }
        </Select>
    )
} 

export default StatusSelector